// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationInfo: React.FC<{ width?: number; height?: number }> = ({ width = 18, height = 18 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9 18c4.957 0 9-4.043 9-9s-4.043-9-9-9-9 4.043-9 9 4.043 9 9 9ZM7.875 5.625A1.11 1.11 0 0 1 9 4.5a1.11 1.11 0 0 1 1.125 1.125A1.11 1.11 0 0 1 9 6.75a1.11 1.11 0 0 1-1.125-1.125Zm-.281 2.25H9.28c.457 0 .844.387.844.844v3.094h.281c.457 0 .844.386.844.843a.855.855 0 0 1-.844.844H7.594a.855.855 0 0 1-.844-.844c0-.457.387-.844.844-.844h.843v-2.25h-.843a.855.855 0 0 1-.844-.843c0-.457.387-.844.844-.844Z"
            />
        </svg>
    );
};

export default React.memo(NotificationInfo);
